import { Helmet } from "react-helmet";
import React from "react";

export default function Base({ children }) {
  return (
    <section>
      <Helmet>
        <title>GigIndia - Paid Part Time Jobs and Top Gigs for Freelancers</title>
        <meta
          name="description"
          content="GigIndia is a technology-driven platform through which businesses can outsource their short term valuable projects to the freelancer community of India."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <link href="/min.css" rel="stylesheet" />
        <link href="/materialize.min.css" rel="stylesheet" />
        <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
        <link
          href="https://fonts.googleapis.com/css?family=Poppins:200,300,400,600"
          rel="stylesheet"
        />
        <link rel="shortcut icon" href="/giglogo.png" />
        <script src="/materialize.min.js" />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
        <script src="//cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/ScrollMagic.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/plugins/debug.addIndicators.min.js"></script>
      </Helmet>
      {children}
    </section>
  );
}
